import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsShoppingPwaFlightSearchResultsFlightsSearch } from '__generated__/api';
import CheapestListingInfo = FlightsShoppingPwaFlightSearchResultsFlightsSearch.CheapestListingInfo;

export class CheapestListingInfoStore extends Store {
  @observable public cheapestListingInfo: CheapestListingInfo;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public clear(): void {
    this.hydrate(CheapestListingInfoStore.DEFAULTS);
  }
}

CheapestListingInfoStore.DEFAULTS = {
  cheapestListingInfo: {
    price: null,
    analytics: null,
    nffAnalytics: null,
    deviationAnalytics: null
  }
};
